import styled from "styled-components";
import { Atom } from 'AppReact';

const WeekText = styled.div`
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  font-weight: 600;
  color: #333333;
  text-align: center;
  width: 14.28%;
  margin-top: 24px;
`;

export default Atom({ type: 'label', dataType: 'string', template: WeekText })